import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=ea822e74&"
import script from "./setPrice.vue?vue&type=script&lang=js&"
export * from "./setPrice.vue?vue&type=script&lang=js&"
import style0 from "./setPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports